module.exports = __webpack_public_path__ + "static/media/spa-rocks.bed59e96.svg";